module.exports = __webpack_public_path__ + "img/cs2.0cc66aa4.png";